<template>
<div>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <!-- <v-card-title>
     Vehicle Brand List
    </v-card-title> -->
    <v-card-title>
      
        <v-btn
              color="primary"
              dark
              class="ma-2"
              @click="addData"
              v-if="role.create"
            >
             Add Brand
            </v-btn>
        <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            class="ma-2"
            v-bind="attrs"
            v-on="on"
          >
            Export To XLS
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <downloadExcel
                    :data="dataExport(table)"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    All Record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    :data="exportDisplayedPage"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    Displayed record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    :data="exportAllFitered"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    All filtered record
                  </downloadExcel>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100]}"
      :options="{'itemsPerPage':50}"
    >
    
     <template v-slot:[`item.list_type`]="{ item }">
          <v-btn
            color="primary"
            dark
            x-small
            @click="modalOpenList(item)"
          >
            <v-icon dark x-small>
              airport_shuttle
            </v-icon>
          </v-btn>
    </template>
     <template v-slot:[`item.actions`]="{ item }">
      <!-- <v-icon
        small
        class="mr-2"
        @click="editData(item.id)"
        v-if="role.update"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteConfirmation(item.id)"
         v-if="role.delete"
      >
        mdi-delete
      </v-icon> -->
        <v-menu  offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            x-small
            v-bind="attrs"
            v-on="on"
            
          >
            <v-icon dark x-small>
              mdi-format-list-bulleted-square
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="role.update" @click="editData(item.id)">
            <v-list-item-title x-small>Edit</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="role.delete" @click="deleteConfirmation(item.id)">
            <v-list-item-title >Delete</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    
    </v-data-table>
  </v-card>
    </template>
  </resizable-page>
  </v-app>
  <modal ref="modalList" class="coba">
      <template v-slot:header>
        <h3>List Vehicle Type</h3>
      </template>

      <template v-slot:body>
        <list-vehicle-type :data_id="$refs.modalList.data" />
      </template>

      <!-- <template v-slot:footer>
        <md-card-actions>
          <md-button @click="modalCloseList">
            Close
          </md-button>
        </md-card-actions>
      </template> -->
    </modal>
</div>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import Swal from "sweetalert2";
import JsonExcel from "vue-json-excel";
import { Modal } from "@/components"
import ListVehicleType from "@/pages/Dashboard/Workshop/VehicleType/modal/ListVehicleType.vue";
import { ResizablePage } from "@/components";

  export default {
    components: {
    downloadExcel: JsonExcel,ResizablePage,
    Modal,
    ListVehicleType
  },
    vuetify,
    data () {
      return {
        loadTable: true,
        role: "",
        search: '',
        headers: [
          {
            text: 'Vehicle Brand Name',
            align: 'start',
            value: 'vehicle_brand_name',
          },
          { text: 'List Type', value: 'list_type', align: 'center', sortable: false },
          { text: 'Actions', value: 'actions', align: 'center', sortable: false },
        ],
        table: [],
        worksheetName: "Vehicle Brand",
        fileName:"Vehicle Brand.xls",
        exportDisplayedPage:[],
        exportAllFitered:[],
        field_export: {
          no: "no",
          vehicle_brand_name: "vehicle_brand_name",
          created_at: "created_at",
          updated_at: "updated_at",
        },
      }
    },
    async created() {
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];
    this.getList();
    },
     methods: {
       // ambil data yang dibutuhkan
    async getList() {
     
      await this.$store.dispatch("workshop_vehicle_brand/list");
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) {
        this.table = await this.$store.getters["workshop_vehicle_brand/list"];
      // }
      // else{
      //   this.table = []
      // }
      this.loadTable= false
    },

    getFiltered(data){
    this.exportDisplayedPage = this.dataExport(data)
    if(this.$refs.vTable){
      this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
    }
    else{
      this.exportAllFitered = this.dataExport(this.table)
    }
    },

    
    modalOpenList(item) {
      this.$refs.modalList.openModal({ id: item.id, name: item.vehicle_brand_name });
    },

    modalCloseList() {
      this.$refs.modalList.closeModal();
    },
    // fungsi tombol direct ke add page
    addData() {
      // panggil add page
    this.$router.push({ name: "Add Vehicle Type" });
    },

    // fungsi tombol direct ke edit page
    editData(id) {
      // panggil edit page
     this.$router.push({ name: "Edit Vehicle Type", params: { id: id } });
    },

  
    // validasi delete data
    deleteConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteData(id);
        }
      });
    },

     // fungsi delete
    async deleteData(id) {
      try {
        // kirim data ke api
        await this.$store.dispatch("workshop_vehicle_brand/destroy", id)
        // panggil alert success
        await this.$store.dispatch("alerts/success", "Spare Part Master data delete successfully.")
        //await this.getList();
        var indexOptionTable = this.table.findIndex(p => p.id ==  id)
           this.table.splice(indexOptionTable, 1)
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
      }
    },
    //fungsi untuk mengubah data yang siap di export data ke xls, saat dipanggil di awal dan dipanggil berulang kali di fungsi filter
      dataExport(data){
       return data.map((v,index) => ({...v, no: index+1}))
      
     
      }
     },
  }
</script>
<style lang="scss" scoped>

.coba{
  width:800px !important;
  margin: 50px auto !important;
  
  @media screen and (max-width: 992px) {
      width: 90% !important;
    }
}

.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
</style>